<template>
  <v-app>
    <v-app-bar app flat color="white" class="full-header">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pl-md-5">
      <v-skeleton-loader
        v-if="loading"
        type="article"
        class="mt-10"
      ></v-skeleton-loader>
      <v-container fluid v-if="!loading">
        <v-row v-show="!hotelsList.length">
          <v-col cols="12">
            <v-alert
              v-show="!hotelsList.length"
              v-if="hotelsSearched"
              border="bottom"
              colored-border
              type="warning"
              elevation="2"
              >No results found.</v-alert
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-card
              class="mx-auto mb-7 mt-5"
              max-width="100%"
              v-show="hotelsList.length"
              v-for="item in hotelsList"
              :key="item.id"
            >
              <v-row>
                <v-col cols="12" md="5" class="pt-0 pb-0">
                  <v-carousel
                    hide-delimiters
                    class
                    height="240"
                    v-if="item.pictures"
                  >
                    <v-carousel-item
                      v-for="(items, i) in item.pictures"
                      :key="i"
                      :src="
                        $store.state.baseUrl +
                          'listing/thumb320x240-' +
                          items.file_name
                      "
                    ></v-carousel-item>
                  </v-carousel>
                </v-col>
                <v-col cols="12" md="7" class="pa-10 pa-md-0">
                  <v-btn class="right-top" icon color="grey">
                    <v-icon>mdi-heart-plus</v-icon>
                  </v-btn>
                  <div class="pt-3 pr-16 subtitle-2">
                    {{ $t(item.type) }} - {{ $t(item.category) }}
                  </div>
                  <div class="text-h6 pr-16">{{ item.name }}</div>
                  <div class="mt-2 grey--text">
                    {{ item.no_rooms }} - {{ $tc("Room", 2) }},
                    {{ item.no_bathrooms }} -
                    {{ $tc("Bathroom", 2) }}
                  </div>
                  <div class="mt-5">
                    <span>
                      <span class="subtitle-2 grey--text"
                        >{{ item.currency_code }}
                      </span>
                      <span
                        class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                        >{{ item.price }}
                      </span>
                      <span class="subtitle-2 grey--text">
                        / {{ $t("Night") }}</span
                      >
                    </span>
                  </div>
                  <div class="mb-5">
                    <p class="my-2" v-if="item.reviews && item.reviews.length">
                      <v-icon color="green" small>mdi-star-circle</v-icon>
                      {{ item.reviews.length }}
                      {{ $t("Reviews") }}
                    </p>
                    <v-btn
                      class="mt-2"
                      color="light-blue"
                      dark
                      :to="{
                        name: 'GuestViewListing',
                        params: { id: item._id }
                      }"
                      >{{ $t("ViewAndBookNow") }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              class="mx-auto mb-7 mt-5"
              max-width="100%"
              v-show="nonHotelsList.length"
              v-for="item in nonHotelsList"
              :key="item.id"
            >
              <v-row>
                <v-col cols="12" md="5" class="pt-0 pb-0">
                  <v-carousel
                    hide-delimiters
                    class
                    height="180"
                    v-if="item.pictures"
                  >
                    <v-carousel-item
                      v-for="(items, i) in item.pictures"
                      :key="i"
                      :src="
                        $store.state.baseUrl +
                          'listing/non-partner/thumb320x240-' +
                          items.file_name
                      "
                    ></v-carousel-item>
                  </v-carousel>
                </v-col>
                <v-col cols="12" md="7" class="pa-10 pa-md-0">
                  <div class="pt-3 pr-16 subtitle-2">
                    <div class="text-h6 pr-16">{{ item.name }}</div>
                    <div class="mt-2 grey--text" v-if="item.no_rooms">
                      {{ item.no_rooms }} - {{ $tc("Room", 2) }}
                    </div>
                    <div class="mt-3">
                      <span class="red--text">* {{ $t("s1660086222") }}</span>
                    </div>
                    <div class="mb-5">
                      <v-btn
                        class="mt-2"
                        color="light-blue"
                        dark
                        :to="{
                          name: 'GuestViewNPListing',
                          params: { id: item._id }
                        }"
                        >{{ $t("s1660119078") }}
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="fixed-map d-none d-sm-inline-flex"
            v-if="location && !hotelsSearched"
          >
            <l-map
              :zoom="zoom"
              :center="[location.lat, location.lng]"
              style="height: 100vh"
            >
              <l-tile-layer :url="url" :attribution="attribution" />
              <l-marker
                :key="index"
                v-for="(list, index) in hotelsList"
                :lat-lng="[list.position[1], list.position[0]]"
              >
                <l-popup>
                  <router-link
                    class="text-decoration-none"
                    :to="{
                      name: 'GuestViewListing',
                      params: { id: list._id }
                    }"
                  >
                    <v-img
                      min-width="300px"
                      max-height="150"
                      v-if="list.pictures[0]"
                      :src="
                        $store.state.baseUrl +
                          'listing/thumb320x240-' +
                          list.pictures[0].file_name
                      "
                    ></v-img>
                    <div
                      class="subtitle-1 light-blue--text text--darken-4 font-weight-bold"
                    >
                      {{ list.name }}
                    </div>
                    <div class="mt-0">
                      <span class="subtitle-1 grey--text"
                        >{{ list.currency_code }}
                      </span>
                      <span
                        class="subtitle-1 light-blue--text text--darken-4 font-weight-bold"
                        >{{ list.price }}
                      </span>
                      <span class="subtitle-1 grey--text">
                        / {{ $t("Night") }}</span
                      >
                    </div>
                  </router-link>
                </l-popup>
              </l-marker>
            </l-map>
          </v-col>
        </v-row>
        <!-- Please stand by dialog -->
        <v-dialog v-model="waitDialog" persistent width="50%">
          <v-card color="light-blue" dark>
            <v-card-text class="pt-5">
              <div class="subtitle-1 text-center pb-3">Please stand by</div>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Please stand by dialog -->
      </v-container>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import ListingService from "@/services/ListingService";
import { LPopup } from "vue2-leaflet";

export default {
  name: "Listing",
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    LPopup
  },
  data() {
    return {
      loading: true,
      waitDialog: false,
      location: this.$store.state.searchQuery,
      hotelsList: [],
      nonHotelsList: [],
      hotelsSearched: false,
      events: [],
      zoom: 12,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  },
  created: async function() {
    if (this.location) {
      await ListingService.searchListings({
        lat: this.location.lat,
        lng: this.location.lng,
        prefered_currency: this.$store.state.user.prefered_currency
      })
        .then(result => {
          const resultList = result.data.list.map(property => {
            let { pictures } = property;
            pictures.sort((a, b) => a.order - b.order);
            return { ...property, pictures };
          });
          this.hotelsList = resultList;
          this.nonHotelsList = result.data.nonlist;
          if (!result.data.list.length && !result.data.nonlist.length) {
            this.hotelsSearched = true;
          } else {
            this.hotelsSearched = false;
          }
          this.loading = false;
        })
        .catch(err => {
          this.error = err.response.data.errors;
        });
    } else {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {}
};
</script>

<style>
.fixed-map .leaflet-container {
  position: fixed;
  height: 100vh !important;
  top: 64px;
  right: 0;
  max-width: 48%;
}
</style>
